import { Flex, VStack } from 'components/uikit';

function Action({ children }: { children?: React.ReactNode }) {
  return (
    <VStack h='100%' flex={1} alignItems='center' justifyContent='center'>
      {children}
    </VStack>
  );
}

export function ActionLayout({ children }: { children: React.ReactNode }) {
  return (
    <Flex w='100%' h='100%'>
      {children}
    </Flex>
  );
}

ActionLayout.Action = Action;
